/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { useOrderDetailContext } from '@euler/app/flows/order/components/OrderDetailProvider';
import { kNullVIN } from '@euler/functions/constants';
import {
  formatCarwashType,
  formatOldPartDisposableType,
  formatReservationType,
  formatReturnType,
} from '@euler/functions/order/enumValueUtil';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { formatDate } from '@euler/utils/formatters';
import { memo } from 'react';
import { OrderInfoCell as Cell } from './Cell';
import { ExtendedPropertiesCells } from './ExtendedPropertiesCells';
import { OrderInfoSection as Section } from './Section';
import { VehicleSubscriptionQrcode } from './VehicleSubscriptionQrcode';

export const BasicInfoSection = memo(
  ({
    hideEstimatedTime,
    hideTitle,
    hideVIN,
    hideMileage,
    hideTags,
    hideRemark,
    hideServiceAgent,
    hideQrcode,
  }: {
    hideEstimatedTime?: boolean;
    hideTitle?: boolean;
    hideVIN?: boolean;
    hideMileage?: boolean;
    hideTags?: boolean;
    hideRemark?: boolean;
    hideServiceAgent?: boolean;
    hideQrcode?: boolean;
  }) => {
    const {
      vin,
      tags,
      vehicleMileage,
      serviceAgentName,
      carwashType,
      reservationType,
      oldPartDisposalType,
      returnType,
      estimatedFinishTime,
      insuranceExpiryDate,
      remark,
    } = useOrderDetailContext();
    const { rpx } = useResponsiveContext();
    return (
      <Section title={hideTitle ? '' : '订单信息'}>
        {!hideQrcode && (
          <VehicleSubscriptionQrcode
            css={`
              margin: ${rpx(15)}px 0;
            `}
          />
        )}
        {!hideTags && <Cell title="业务类型" detail={tags?.join(',')} />}
        {!hideVIN && vin !== kNullVIN && <Cell title="车架号" detail={vin} />}
        {!hideMileage && vehicleMileage > 0 && (
          <Cell title="进店里程" detail={`${vehicleMileage}公里`} />
        )}
        {!hideServiceAgent && (
          <Cell title="服务顾问" detail={serviceAgentName} />
        )}
        <Cell
          title="保险到期日期"
          detail={insuranceExpiryDate ? formatDate(insuranceExpiryDate) : '无'}
        />
        <Cell title="取车前是否洗车" detail={formatCarwashType(carwashType)} />
        <Cell
          title="服务是否预约"
          detail={formatReservationType(reservationType)}
        />
        <Cell
          title="维修旧件处理方式"
          detail={formatOldPartDisposableType(oldPartDisposalType)}
        />
        <Cell title="车辆归还方式" detail={formatReturnType(returnType)} />
        {!hideEstimatedTime && (
          <Cell
            title="预计交车时间"
            detail={
              estimatedFinishTime ? formatDate(estimatedFinishTime) : '无'
            }
          />
        )}
        <ExtendedPropertiesCells />
        {!hideRemark && <Cell title="服务备注" detail={remark || '无'} last />}
      </Section>
    );
  },
);
